const colours = {
  white: '#ffffff',
  catSkillWhite: '#eff2f7',
  black: '#212121',
  primary400: '#58ACDC', // 400,500,600 according to the design colour palette.
  primary: '#004a8c',
  primary600: '#2E7FBA',
  primary700: '#002A64',
  success400: '#97CD6C',
  success: '#6aad40',
  success600: '#4F942E',
  success700: '#387C20',
  warning400: '#FACD3E',
  warning: '#f7b500',
  warning600: '#D49500',
  warning700: '#B17800',
  error400: '#CF3341',
  error: '#b00020',
  error600: '#970029',
  error700: '#7E002E',
  info400: '#66D0E3',
  info: '#38AFD1',
  info600: '#288AB3',
  info700: '#1C6996',
  primaryDarker: '#003a74', //Remove.
  aquaHaze: '#f1f4f7',
  athensGray: '#e6eaee',
  gallery: '#EDEDED',
  osloGray: '#9A9EA0',
  nevada: '#626668',
  inputBorder: '#c7d0d9', //Phase out this. Not a suitable colour name. Use ghost instead.
  ghost: '#C7D0D9',
  lightBorder: '#e1e4e8',
  darkerText: '#666666',
  lightText: '#9e9e9e',
  nobel: '#b3b3b3',
  negative: '#f36274',
  secondary: '#38afd1', // Phase out. Use info instead.
  primaryDisabled: '#789FC2',
  secondaryDisabled: '#95D1E4',
  yellow: '#e5ad12',
  halfColonialWhite: '#fdf0cc',
  red: '#df4545',
  beautyBush: '#ECB4BE',
  vanillaIce: '#efccd2',
  zanah: '#e1efd9',
};

export default colours;
